// Date formatting shared across the Console. Times are shown in Taiwan time.

const TIMEZONE = "Asia/Taipei";

const locale = (lng) => (lng === "en" ? "en-US" : "zh-TW");

// "2026年10月15日 09:30" / "Oct 15, 2026, 09:30". "-" when missing or invalid.
export const formatDateTime = (iso, lng) => {
  const date = iso ? new Date(iso) : null;
  if (!date || Number.isNaN(date.getTime())) return "-";
  return new Intl.DateTimeFormat(locale(lng), {
    year: "numeric",
    month: lng === "en" ? "short" : "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: TIMEZONE,
  }).format(date);
};

// "2027-06-30" → "2027年6月30日" / "Jun 30, 2027". "-" when missing or invalid.
export const formatDate = (date, lng) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(date || "");
  if (!match) return "-";
  const [, year, m, d] = match.map(Number);
  return new Intl.DateTimeFormat(locale(lng), {
    year: "numeric",
    month: lng === "en" ? "short" : "long",
    day: "numeric",
    timeZone: "UTC",
  }).format(new Date(Date.UTC(year, m - 1, d)));
};
